import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "relative bg-white rounded-xl p-5 shadow-lg hover:shadow-xl border border-white hover:border-light-3 p-5" }
const _hoisted_2 = { class: "absolute top-5 right-5" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "font-bold text-center mb-3" }
const _hoisted_5 = { class: "text-sm text-center" }
const _hoisted_6 = { class: "bg-light-1 rounded-xl border border-light-1 flex justify-between items-center px-4 py-2.5 mt-6" }
const _hoisted_7 = { class: "text-sm" }
const _hoisted_8 = { class: "font-bold" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", null, " Revenue generated", -1)
const _hoisted_10 = {
  key: 0,
  class: "bg-green-400 rounded-md text-white flex items-center flex-start p-2"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "text-xs mr-1 leading-3" }, "+8%", -1)
const _hoisted_12 = { class: "flex justify-between items-center mt-4" }
const _hoisted_13 = { class: "text-sm" }
const _hoisted_14 = { class: "font-bold" }
const _hoisted_15 = { class: "text-sm" }
const _hoisted_16 = { class: "font-bold" }
const _hoisted_17 = { class: "text-sm" }
const _hoisted_18 = { class: "font-bold" }
const _hoisted_19 = { class: "flex justify-between items-center mt-9" }
const _hoisted_20 = { class: "flex justify-start items-center" }
const _hoisted_21 = { class: "text-sm" }
const _hoisted_22 = { class: "flex items-center py-1 ml-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_toggle = _resolveComponent("app-toggle")!
  const _component_app_icon = _resolveComponent("app-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_app_toggle, {
        active: _ctx.automation.status === 'enabled',
        "onUpdate:active": _ctx.changeStatus
      }, null, 8, ["active", "onUpdate:active"])
    ]),
    _createElementVNode("div", {
      innerHTML: _ctx.automation.icon,
      class: "automation-icon-wrapper flex justify-center items-center mb-3"
    }, null, 8, _hoisted_3),
    _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t("pages.automations." + _ctx.automation.type + ".name")), 1),
    _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t("pages.automations." + _ctx.automation.type + ".description")), 1),
    (_ctx.automation.status === 'enabled')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (_ctx.stats !== undefined)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.stats.total_revenue), 1),
                    _hoisted_9
                  ]),
                  false
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        _hoisted_11,
                        _createVNode(_component_app_icon, {
                          name: "TrendingUp",
                          size: "3"
                        })
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.stats.total_sent), 1),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t("components.card.automation.mails")), 1)
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.stats.open_rate.toFixed(1)) + "%", 1),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t("components.card.automation.openRate")), 1)
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.stats.total_conversions), 1),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t("components.card.automation.conversions")), 1)
                  ])
                ])
              ], 64))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _createVNode(_component_app_icon, {
                name: "CheckCircle",
                class: "text-green-400 mr-1",
                size: "5"
              }),
              _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.$t("components.card.automation.activeSince")) + " " + _toDisplayString(_ctx.activeSince), 1)
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("span", {
                class: "flex justify-center w-20 text-sm py-1 leading-6 bg-light-2 border border-light-2 hover:bg-light-3 hover:border-light-3 rounded-md cursor-pointer",
                onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.goToAutomation && _ctx.goToAutomation(...args)), ["stop"]))
              }, _toDisplayString(_ctx.$t("general.view")), 1)
            ])
          ])
        ], 64))
      : _createCommentVNode("", true)
  ]))
}